var App = App || {};

App.VideoLibrary = (() => {
    'use strict';

    const youtube = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    };

    const vimeo = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    };

    const init = (id) => {
        const widget = document.getElementById(id);
        const modal = document.getElementById(`video-modal-${id}`);

        modal.addEventListener('show.bs.modal', event => {
            let title = event.relatedTarget.dataset.title;
            let src = event.relatedTarget.dataset.src;
            let transcript = event.relatedTarget.dataset.transcript;

            document.getElementById(`video-modal-title-${id}`).innerText = title;

            switch (true) {
                case src.toLowerCase().includes('youtube'):
                    modal.querySelector('.modal-body').innerHTML = youtube(src, title);
                    break;
                case src.toLowerCase().includes('vimeo'):
                    modal.querySelector('.modal-body').innerHTML = vimeo(src, title);
                    break;
                default:
                    console.log('Could not locate video content for source:', src);
            }

            if (transcript) {
                modal.querySelector('.modal-body').innerHTML += `<div class="video-transcript"><a href="${transcript}" target="_blank">Transcript</a></div>`;
            }
        });

        modal.addEventListener('hidden.bs.modal', () => {
            document.getElementById(`video-modal-title-${id}`).innerText = '';
            modal.querySelector('.modal-body').innerHTML = '';
        });
    };

    return {
        init: init
    };
})();
